import React, { useState, useEffect } from "react";
import HiOutlineMenuAlt1 from "react-icons/hi";
import BsFillSunFill from "react-icons/bs";
import MdDarkMode from "react-icons/md";
import "./style.css";
export default function NavBar(props) {
  const activePage = document.location.pathname;
  useEffect(() => {
    return () => {
      if (activePage === "/") {
        document.getElementsByClassName("home")[0].style.backgroundColor =
          "rgba(190, 52, 84, 0.1)";
      }
      if (activePage === "/about") {
        document.getElementsByClassName("about")[0].style.backgroundColor =
          "rgba(190, 52, 84, 0.1)";
      }
      if (activePage === "/projects") {
        document.getElementsByClassName("projects")[0].style.backgroundColor =
          "rgba(190, 52, 84, 0.1)";
      }
      if (activePage === "/contact") {
        document.getElementsByClassName("contact")[0].style.backgroundColor =
          "rgba(190, 52, 84, 0.1)";
      }
    };
  }, []);
  return (
    <>
      <div>
        <div>Madhavi Gupta</div>
        <ul style={{ listStyle: "none", display: "flex" }}>
          <li>
            <a href="/" className="listItems home">
              Home
            </a>
          </li>
          <li>
            <a href="/about" className="listItems about">
              About
            </a>
          </li>
          <li>
            <a href="/projects" className="listItems projects">
              Projects
            </a>
          </li>
          <li>
            <a href="/contact" className="listItems contact">
              Contact
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
